'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parallel = undefined;

var _deprecate = require('./deprecate');

var _deprecate2 = _interopRequireDefault(_deprecate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Executes all functions in parallel. (Simple wrapper around Promise.all)
 *
 * @param fns, a list of functions to be executed in parallel
 */
var parallel = exports.parallel = function parallel() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    (0, _deprecate2.default)('\n    In the next major version parallel will be replaced by parallelObject.\n    This means that parallel will accept an array as first argument instead\n    of a list of arguments.\n    parallel(() => Promise.resolve(1), () => Promise.resolve(2))\n    needs to be replaced by\n    parallel([() => Promise.resolve(1), () => Promise.resolve(2)])\n  ');

    return Promise.all(fns.map(function (fn) {
      return fn();
    }));
  };
};